import { createSlice } from '@reduxjs/toolkit';

export const shiftSchedulingGlobalRulesSlice = createSlice({
  name: 'shiftSchedulingGlobalRules',
  initialState: {
    list: [],
    shiftSchedulingGlobalRule: null,
  },
  reducers: {
    setShiftSchedulingGlobalRules: (state, action) => {
      state.list = action.payload;
    },
    setShiftSchedulingGlobalRule: (state, action) => {
      state.shiftSchedulingGlobalRule = action.payload;
    },
  },
});

export const { setShiftSchedulingGlobalRules, setShiftSchedulingGlobalRule } =
  shiftSchedulingGlobalRulesSlice.actions;
